import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? "bg-transparent"
          : "bg-background-50"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className={`ri-book-3-line text-xl ${isHome && !scrolled ? "text-white" : "text-primary-500"}`}></i>
            </div>
            <span className={`font-heading font-bold text-base ${isHome && !scrolled ? "text-white" : "text-foreground-950"}`}>
              韩漫大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={`text-sm whitespace-nowrap transition-colors cursor-pointer ${isHome && !scrolled ? "text-white/80 hover:text-white" : "text-foreground-700 hover:text-primary-500"}`}>
              首页
            </Link>
            <Link to="/category/romance" className={`text-sm whitespace-nowrap transition-colors cursor-pointer ${isHome && !scrolled ? "text-white/80 hover:text-white" : "text-foreground-700 hover:text-primary-500"}`}>
              分类
            </Link>
            <Link to="/about" className={`text-sm whitespace-nowrap transition-colors cursor-pointer ${isHome && !scrolled ? "text-white/80 hover:text-white" : "text-foreground-700 hover:text-primary-500"}`}>
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/romance"
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                isHome && !scrolled
                  ? "bg-white/20 text-white hover:bg-white/30"
                  : "bg-primary-500 text-background-50 hover:bg-primary-600"
              }`}
            >
              开始阅读
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${isHome && !scrolled ? "text-white" : "text-foreground-950"}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm text-foreground-700 py-2 cursor-pointer">首页</Link>
            <Link to="/category/romance" className="text-sm text-foreground-700 py-2 cursor-pointer">分类</Link>
            <Link to="/about" className="text-sm text-foreground-700 py-2 cursor-pointer">关于我们</Link>
            <Link to="/category/romance" className="bg-primary-500 text-background-50 text-center py-2 rounded-full text-sm font-medium cursor-pointer">开始阅读</Link>
          </div>
        </div>
      )}
    </nav>
  );
}